import { CAMPAIGNS_API } from 'modules/campaigns/api/constants'
import { CampaignId } from 'modules/campaigns/types/campaign-interface'
import { ContactCampaignStepInterface } from 'modules/contacts/types/contact-menu-interface'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { DataWithPaginationInterface } from 'shared/types/pagination-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useFetch } from 'shared/hooks/use-fetch'

interface UseContactCampaignsProps {
  shouldFetch: boolean
  id: CampaignId | undefined
}

export function useContactCampaigns({ shouldFetch, id }: UseContactCampaignsProps) {
  const { user } = useUser()

  const { fetcher } = useFetch<
    RequestMethodsEnum.get,
    DataWithPaginationInterface<ContactCampaignStepInterface>
  >({
    method: RequestMethodsEnum.get,
  })

  const { data: campaignSteps, isValidating: isStepsValidating } = useControlledSwr(
    () =>
      shouldFetch &&
      id !== undefined && [`${CAMPAIGNS_API}/${id}/list-steps`, RequestModuleEnum.CampaignStep],
    fetcher,
    undefined,
    !!user,
  )

  return { campaignSteps, isStepsValidating }
}
